import * as ISchema from "#webapp/src/__schema__";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { ZonedMoment } from "@clockwise/client-commons/src/util/ZonedMoment";
import { QueryStringParams } from "@clockwise/web-commons/src/util/post-message-common.util";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOpenShareLinkModal } from "../state/actions/chrome-extension.actions";
import { group } from "../util/analytics.util";
import { fromGlobalId } from "../util/graphql.util";
import { PostMessageManager } from "../util/post-message.util";

export const useDetectLogin = (
  user: ISchema.IUser,
  org: ISchema.IOrg | null,
  onUserLoggedIn: () => void,
  calendarUrl: string,
) => {
  const prevUserRef = useRef(user);
  const dispatch = useDispatch();
  const mode = useSelector((state: IReduxState) => state.webExtension.mode);
  const chromeExtensionOpen = useSelector(
    (state: IReduxState) => state.webExtension.webExtensionOpen,
  );

  useEffect(() => {
    if (user && !prevUserRef.current) {
      if (org && org.id) {
        group(`Org::${fromGlobalId(org.id).id}`, {
          name: org.name,
          created: new ZonedMoment(org.createdTime),
        });
      }

      onUserLoggedIn();

      const url = mode === "extension" ? calendarUrl || "" : window.location.href;
      const search = url.split("?")[1];
      const searchParams = new URLSearchParams(search);

      if (searchParams.has(QueryStringParams.ShareSchedulingLink)) {
        // if we are not open, open
        if (!chromeExtensionOpen) {
          PostMessageManager.toggleSidebar(true, false);
        }
        setTimeout(() => {
          dispatch(setOpenShareLinkModal(true));
          PostMessageManager.clearQueryParams(QueryStringParams.ShareSchedulingLink);
        }, 500);
      }
    }

    prevUserRef.current = user;
  }, [calendarUrl, chromeExtensionOpen, dispatch, mode, onUserLoggedIn, org, user]);
};
